import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de9bad6046f12a/components/forms/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/app/[locale]/contact/contact.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleMapLazy"] */ "/tmp/8de9bad6046f12a/components/ui/GoogleMapLazy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Section.module.css");
